import { render } from "./AadharOtp.vue?vue&type=template&id=4058be58&scoped=true"
import script from "./AadharOtp.vue?vue&type=script&lang=js"
export * from "./AadharOtp.vue?vue&type=script&lang=js"

import "./AadharOtp.vue?vue&type=style&index=0&id=4058be58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4058be58"]])

export default __exports__